import requestAction from '../../utils/requestAction'

export const fetchIncoterms = (params: string = "") =>
  requestAction('INCOTERMS_LIST', params)(`incoterms`, 'GET')
